import { render, staticRenderFns } from "./HeadingSettings.vue?vue&type=template&id=b3a1c2b4&scoped=true"
import script from "./HeadingSettings.vue?vue&type=script&lang=ts"
export * from "./HeadingSettings.vue?vue&type=script&lang=ts"
import style0 from "./HeadingSettings.vue?vue&type=style&index=0&id=b3a1c2b4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a1c2b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3a1c2b4')) {
      api.createRecord('b3a1c2b4', component.options)
    } else {
      api.reload('b3a1c2b4', component.options)
    }
    module.hot.accept("./HeadingSettings.vue?vue&type=template&id=b3a1c2b4&scoped=true", function () {
      api.rerender('b3a1c2b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/HeadingSettings.vue"
export default component.exports